import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouterHooks } from "../../../withRouters/withRoutersHook";
import { RenderPDFTemplateInstanceAction } from "../../../Actions/Forms";
import axios from "../../../Actions/Axios";
import {
  ArrowLeft,
  Download,
  Loader2,
  AlertCircle,
} from "lucide-react";

class PDFTemplatePreview extends Component {
  static propTypes = {
    RenderPDFTemplateInstanceAction: PropTypes.func.isRequired,
    navigate: PropTypes.func.isRequired,
    params: PropTypes.object,
  };

  state = {
    loading: true,
    error: null,
    pdfUrl: null,
    instanceId: null,
    pages: [],
    loadingPages: false,
  };

  async componentDidMount() {
    const instanceId = this.props.params?.id;
    if (!instanceId) {
      this.props.navigate("/dashboard/smartflow");
      return;
    }
    try {
      const data = await this.props.RenderPDFTemplateInstanceAction(instanceId);
      this.setState(
        {
          loading: false,
          pdfUrl: data.pdf_url,
          instanceId: data.instance_id,
          loadingPages: true,
        },
        () => this.loadAllPages(data.instance_id, data.page_count || 1)
      );
    } catch {
      this.setState({ loading: false, error: "Failed to generate PDF. Please try again." });
    }
  }

  loadAllPages = async (instanceId, pageCount) => {
    const pages = [];
    for (let i = 0; i < pageCount; i++) {
      try {
        const res = await axios.get(
          `/api/form/pdf-template-instances/${instanceId}/pages/${i}/`
        );
        pages.push(res.data.image);
      } catch {
        pages.push(null);
      }
    }
    this.setState({ pages, loadingPages: false });
  };

  render() {
    const { loading, error, pdfUrl, pages, loadingPages } = this.state;

    return (
      <div className="w-full min-h-screen bg-gray-50 flex flex-col">
        {/* Top bar */}
        <div className="sticky top-0 z-10 bg-white border-b border-gray-200 px-6 py-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Link
              to="/dashboard/smartflow"
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <ArrowLeft className="w-5 h-5" />
            </Link>
            <span className="font-SFPro font-semibold text-gray-800">PDF Preview</span>
          </div>
          {pdfUrl && (
            <a
              href={pdfUrl}
              target="_blank"
              rel="noopener noreferrer"
              download
              className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white font-inter font-semibold text-sm rounded-xl hover:bg-blue-700 transition-colors"
            >
              <Download className="w-4 h-4" />
              Download PDF
            </a>
          )}
        </div>

        {/* Content */}
        <div className="flex-1 flex flex-col items-center justify-start p-6">
          {loading ? (
            <div className="flex flex-col items-center gap-4 mt-24">
              <div className="w-16 h-16 rounded-2xl bg-blue-50 flex items-center justify-center">
                <Loader2 className="w-8 h-8 text-blue-400 animate-spin" />
              </div>
              <p className="font-inter text-sm text-gray-400">Generating your PDF…</p>
            </div>
          ) : error ? (
            <div className="flex flex-col items-center gap-4 mt-24">
              <div className="w-16 h-16 rounded-2xl bg-red-50 flex items-center justify-center">
                <AlertCircle className="w-8 h-8 text-red-400" />
              </div>
              <p className="font-inter text-sm text-red-500">{error}</p>
              <button
                onClick={() => window.location.reload()}
                className="px-4 py-2 bg-red-100 text-red-600 font-inter text-sm rounded-xl hover:bg-red-200 transition-colors"
              >
                Try again
              </button>
            </div>
          ) : loadingPages ? (
            <div className="flex flex-col items-center gap-4 mt-24">
              <Loader2 className="w-8 h-8 text-blue-400 animate-spin" />
              <p className="font-inter text-sm text-gray-400">Loading pages…</p>
            </div>
          ) : (
            <div className="w-full max-w-4xl flex flex-col items-center gap-4">
              {pages.map((img, idx) =>
                img ? (
                  <img
                    key={idx}
                    src={`data:image/png;base64,${img}`}
                    alt={`Page ${idx + 1}`}
                    className="w-full rounded-xl border border-gray-200 shadow-sm bg-white"
                  />
                ) : null
              )}
              {pdfUrl && (
                <a
                  href={pdfUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  download
                  className="flex items-center gap-2 px-5 py-2.5 bg-blue-600 text-white font-inter font-semibold text-sm rounded-xl hover:bg-blue-700 transition-colors"
                >
                  <Download className="w-4 h-4" />
                  Download PDF
                </a>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

export default withRouterHooks(
  connect(mapStateToProps, { RenderPDFTemplateInstanceAction })(PDFTemplatePreview)
);
